import { render, staticRenderFns } from "./RegisterSuccessModal.vue?vue&type=template&id=7f770381&scoped=true"
import script from "./RegisterSuccessModal.vue?vue&type=script&lang=ts"
export * from "./RegisterSuccessModal.vue?vue&type=script&lang=ts"
import style0 from "./RegisterSuccessModal.vue?vue&type=style&index=0&id=7f770381&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f770381",
  null
  
)

export default component.exports